import { useEffect, useState } from "react";

const navLinks = [
  { label: "Work", href: "#work" },
  { label: "Studio", href: "#studio" },
  { label: "Process", href: "#process" },
  { label: "Journal", href: "#journal" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-neutral-200"
          : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-10 lg:px-14 h-20 flex items-center justify-between">
        <a
          href="#top"
          className={`font-['Pacifico'] text-2xl tracking-tight cursor-pointer whitespace-nowrap transition-colors ${
            scrolled ? "text-neutral-900" : "text-white"
          }`}
        >
          Inflato
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className={`text-sm font-medium tracking-wide cursor-pointer whitespace-nowrap transition-colors ${
                scrolled
                  ? "text-neutral-700 hover:text-neutral-900"
                  : "text-white/85 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button
            type="button"
            className={`text-sm font-medium px-5 py-2 rounded-full border cursor-pointer whitespace-nowrap transition-all ${
              scrolled
                ? "border-neutral-900 text-neutral-900 hover:bg-neutral-900 hover:text-white"
                : "border-white/70 text-white hover:bg-white hover:text-neutral-900"
            }`}
          >
            Get in touch
          </button>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
            scrolled ? "text-neutral-900" : "text-white"
          }`}
          aria-label="Toggle menu"
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-neutral-200">
          <div className="px-6 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="text-sm font-medium text-neutral-700 hover:text-neutral-900 py-2 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <button
              type="button"
              className="mt-2 text-sm font-medium px-5 py-2.5 rounded-full bg-neutral-900 text-white cursor-pointer whitespace-nowrap"
            >
              Get in touch
            </button>
          </div>
        </div>
      )}
    </header>
  );
}